import { CompleteSystemWCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const CompleteSystemWCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case CompleteSystemWCActionType.CompleteSystemWC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default CompleteSystemWCReducer
